import { Outlet } from "react-router-dom";

const ChatLayout = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default ChatLayout;
